import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Level, Title } from 'rbx';
import styled from 'styled-components';

import Can from '../../../utils/Can';
import { ACLSConsumer } from '../../../utils/aclsContext';

const Wrapper = styled.div`
  padding: 1rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Header = ({ location, isAddBlockUsers }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Title size={2}>Users</Title>
      </Level.Item>
      {!isAddBlockUsers && (
        <Level.Item align="right">
          <ACLSConsumer>
            {({ apiActions, pageActions }) => (
              <Can
                action={`${
                  location.pathname === '/users' ? 'create_user' : 'update_user'
                }`}
                apiActions={apiActions}
                pageActions={pageActions}
                yes={() => (
                  <Link to="/add-user" className="button is-primary">
                    <span className="has-text-weight-semibold">New User</span>
                  </Link>
                )}
              />
            )}
          </ACLSConsumer>
        </Level.Item>
      )}
    </Level>
  </Wrapper>
);

export default withRouter(Header);
